import React from "react";
import _, { isEmpty } from "lodash";

const InputCodeContainer = ({
  errors,
  details,
  onInputChange,
  password_reset_params
}) => {
  console.log(errors, "errors");
  const code_hint = _.get(password_reset_params, "code_hint", "Enter Code");
  const newpass_hint = _.get(
    password_reset_params,
    "newpass_hint",
    "New Password"
  );
  const confirm_hint = _.get(
    password_reset_params,
    "confirm_hint",
    "Confirm Password"
  );
  return (
    <div className="input-container">
      <input
        name="code"
        type="number"
        value={details.code}
        className="input-div emailCode"
        placeholder={code_hint}
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
      />
      {!isEmpty(errors.code) && <p className="error">{errors.code}</p>}
      <input
        name="password"
        type="password"
        value={details.password}
        placeholder={newpass_hint}
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
        className="input-div emailCode"
      />
      {!isEmpty(errors.password) && <p className="error">{errors.password}</p>}
      <input
        name="confirm_password"
        type="password"
        value={details.confirm_password}
        placeholder={confirm_hint}
        onChange={(e) => onInputChange(e.target.value, e.target.name)}
        className="input-div emailCode"
      />
      {!isEmpty(errors.confirm_password) && (
        <p className="error">{errors.confirm_password}</p>
      )}
    </div>
  );
};

export default InputCodeContainer;
